import { Button } from '@/components/ui/button';
import { ArrowLeft, ArrowRight, RefreshCw } from 'lucide-react';
import { WIZARD_STEPS } from './drawdownCreateTypes';
import type { WizardStep } from './drawdownCreateTypes';

interface DrawdownCreateFooterActionsProps {
  currentStep: WizardStep;
  isLoading: boolean;
  canSubmit: boolean;
  onPrevious: () => void;
  onNext: () => void;
  onCancel: () => void;
  onSubmit: () => void;
  onRecalculate?: () => void;
}

export function DrawdownCreateFooterActions({
  currentStep,
  isLoading,
  canSubmit,
  onPrevious,
  onNext,
  onCancel,
  onSubmit,
  onRecalculate,
}: DrawdownCreateFooterActionsProps) {
  const currentIndex = WIZARD_STEPS.indexOf(currentStep);
  const isFirstStep = currentIndex === 0;
  const isLastStep = currentIndex === WIZARD_STEPS.length - 1;
  const showRecalculate = currentStep === 'allocations' && !!onRecalculate;

  return (
    <div className="flex justify-between pt-6 border-t">
      <div className="flex gap-2">
        {!isFirstStep && (
          <Button variant="outline" onClick={onPrevious} disabled={isLoading}>
            <ArrowLeft className="h-4 w-4 mr-2" />
            Previous
          </Button>
        )}
        {showRecalculate && (
          <Button
            variant="outline"
            onClick={onRecalculate}
            disabled={isLoading}
          >
            <RefreshCw className="h-4 w-4 mr-2" />
            {isLoading ? 'Recalculating...' : 'Recalculate'}
          </Button>
        )}
      </div>

      <div className="flex gap-2">
        <Button variant="outline" onClick={onCancel} disabled={isLoading}>
          Cancel
        </Button>

        {isLastStep ? (
          <Button onClick={onSubmit} disabled={!canSubmit || isLoading}>
            {isLoading ? 'Creating...' : 'Create Capital Call'}
          </Button>
        ) : (
          <Button onClick={onNext} disabled={isLoading}>
            Next
            <ArrowRight className="h-4 w-4 ml-2" />
          </Button>
        )}
      </div>
    </div>
  );
}
